<template>
    <div class="chart-wrapper">
      <!-- <div id="main"></div> -->
      <div class="ai-container" >
        <div class="operation">
          <img @click="isHidden = true" src="../../assets/images/del.png" alt="">
        </div>
  
        <div class="tip">
          <div class="img-wrapper">
            <img src="../../assets/images/ai.png" alt="" />
          </div>
          <span>你好，我是辽博知识问答机器人有什么问题尽管问我</span>
        </div>
        <el-scrollbar ref="scrollbarRef" class="flex-1">
          <div class="content-wrapper" ref="bottomElement">
            <div class="item" v-for="(item, index) in historyList" :key="index">
              <div class="item-inner" v-if="item.role == 'assistant'">
                <img src="../../assets/images/pic_ai1.png" alt="">
                <div class="info-box">
                  <!-- <span class="name">您的小AI</span> -->
                  <span class="content" v-html="item.content || ''"> </span>
                </div>
              </div>
  
              <div class="item-inner text-right" v-else>
                <div class="info-box">
                  <!-- <span class="name">{{ $store.state.user.nickname }}</span> -->
                  <span class="content" v-html="item.content"></span>
                </div>
                <img :src="$store.state.user.headImg || defaultImg" alt="" :onerror="defaultImg" />
              </div>
            </div>
          </div>
        </el-scrollbar>
        <div class="ask-wrapper">
          <div class="loading-box" @click="stopAsk" v-if="generating">
            <span class="txt">停止加载</span>
          </div>
  
          <div class="svg-wrapper" @click="setNewSessionId">
            <div class="svg-inner">
              <svg-icon class-name="clear-icon" icon-class="clear" @click.stop="click" />
            </div>
            <div class="theme">新主题</div>
          </div>
  
          <div class="input-wrapper">
            <el-input ref="askRef" type="textarea" maxlength="4000" autosize show-word-limit placeholder="有什么问题尽管问我..." v-model="otherText" @keydown.enter.native="getMore($event)" class="ask"></el-input>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { EventSourcePolyfill } from 'event-source-polyfill'
  
  export default {
    data() {
      return {
        defaultImg: this.$store.state.app.defaultHeadImg,
        sse: {},
        generating: false,
        isHidden: true,
        otherText: '',
        historyList: []
      }
    },
    methods: {
      initCharts() {
        var chartDom = document.getElementById('main')
        var myChart = this.$echarts.init(chartDom)
        var option
        axios.get('/zhishitupu.json').then((res) => {
          let graph = res.data
          graph.nodes.forEach(function (node) {
            node.label = {
              show: node.symbolSize > 30
            }
          })
          option = {
            backgroundColor: '#306159',
            title: {
              text: 'Les Miserables',
              subtext: 'Default layout',
              top: 'bottom',
              left: 'right'
            },
            tooltip: {},
            legend: [
              {
                // selectedMode: 'single',
                data: graph.categories.map(function (a) {
                  return a.name
                })
              }
            ],
            animationDuration: 1500,
            animationEasingUpdate: 'quinticInOut',
            series: [
              {
                name: 'Les Miserables',
                type: 'graph',
                layout: 'none',
                data: graph.nodes,
                links: graph.links,
                categories: graph.categories,
                roam: true,
                label: {
                  position: 'right',
                  formatter: '{b}'
                },
                lineStyle: {
                  color: 'source',
                  curveness: 0.3
                },
                emphasis: {
                  focus: 'adjacency',
                  lineStyle: {
                    width: 10
                  }
                }
              }
            ]
          }
          myChart.setOption(option)
        })
      },
  
      getMore() {
        let e = window.event || arguments[0]
        // console.log(e);
        if (e.key == 'Enter' || e.code == 'Enter' || e.keyCode == 13) {
          e.returnValue = false
          this.createChatCompletion()
          return false
        }
      },
  
      
      stopAsk() {
        this.sse.close()
        let time = setTimeout(() => {
          this.generating = false
          clearTimeout(time)
        }, 500)
      },
  
  
      scrollToBottom() {
        this.$nextTick(() => {
          // p = scrollbar.scrollHeight // 将scrollTop设置为scrollHeight
          const scrollbar = this.$refs.scrollbarRef.$refs.wrap // 获取el-scrollbar的DOM元素
          scrollbar.scrollTo({
            top: scrollbar.scrollHeight, //y 上线
            behavior: 'smooth'
          })
        })
      },
  
      setNewSessionId() {
        this.otherText = ''
        this.sse.close()
        this.historyList = []
        this.generating = false
      },
  
      createChatCompletion() {
        let tenantId,
          count = 0
        const this_ = this
  
        // if (!this.sessionId) {
        //   this.sessionId = this.getUuid()
        // }
        // if (getTenantEnable()) {
        //   tenantId = getTenantId()
        // }
        let sse = new EventSourcePolyfill(
          `/singleMuseum/openai/completions/stream?user=0&prompt=${this.otherText}`,
          {
            heartbeatTimeout: 60 * 1000
          }
        )
        this_.sse = sse
        this_.generating = true
  
        this_.historyList.push({
          role: 'user',
          messageType: 'TEXT',
          content: this_.otherText
        })
        this_.otherText = ''
        sse.addEventListener('open', function () {
          this_.generating = true
          this_.historyList.push({
            role: 'assistant',
            messageType: 'TEXT',
            content: ''
          })
        })
        this_.scrollToBottom()
  
        sse.addEventListener('message', function (res) {
          let resJson = JSON.parse(res.data)
          if (resJson.code !== 0) {
            this.generating = false
            sse.close()
            return
          }
          resJson = resJson.data
          if (resJson.messageType === 'TEXT') {
            if (resJson.end === true) {
              sse.close()
              this_.generating = false
            } else {
              console.log(resJson.message)
              let last = this_.historyList[this_.historyList.length - 1]
              last.content += resJson.message
            }
          }
          this_.scrollToBottom()
  
          // this_.getPage()
        })
  
        sse.addEventListener('error', function (res) {
          this_.generating = false
          sse.close()
          alert('服务器错误，请查看日志')
        })
      }
    },
    mounted() {
      // this.initCharts()
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .chart-wrapper {
    width: 1920px;
    height: calc(100vh - 120px);
    background: url(../../assets/images/bg1.png) no-repeat center;
    background-size: 100% 100%;
  }
  #main {
    width: 100%;
    height: 100%;
  }
  
  .ai-container {
    background-color: #fff;
    width: 440px;
    position: fixed;
    top: 280px;
    right: 40px;
    bottom: 20px;
    padding: 0 15px;
    z-index: 10000;
    background-size: 100% 100%;
  
    display: flex;
    flex-direction: column;
    transition: all linear 0.5s;
  
    &.hidden {
      transform: translateX(200%);
    }
  
    .operation {
      display: flex;
      margin-top: 20px;
      justify-content: end;
  
      img {
        cursor: pointer;
        width: 20px;
        height: 20px;
      }
    }
  
    .tip {
      background: #fff;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 10px;
      border-radius: 8px;
      .img-wrapper {
        width: 64px;
        height: 64px;
        flex-shrink: 0;
        display: flex;
        position: relative;
        top: -50%;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: $primary;
        box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.7);
        img {
          width: 48px;
          height: 48px;
        }
      }
      span {
        margin-left: 20px;
        font-size: 16px;
      }
    }
  
    .content-wrapper {
      flex: 1;
      padding-top: 40px;
      overflow: auto;
  
      .item {
        &:last-child {
          .item-inner {
            margin-bottom: 0;
          }
        }
  
        .item-inner {
          display: flex;
          margin-bottom: 40px;
          align-items: flex-start;
  
          img {
            width: 56px;
            height: 56px;
            margin-right: 13px;
            border-radius: 50%;
          }
  
          .info-box {
            display: flex;
            flex-direction: column;
            position: relative;
            &::before {
              content: '';
              position: absolute;
              top: 28px;
              left: -6px;
              transform: translateY(-50%);
              width: 0;
              height: 0;
              border-top: 6px solid transparent;
              border-bottom: 6px solid transparent;
              border-right: 6px solid #f1f1f1;
            }
            .name {
              margin: 7px 0 15px;
              font-size: 14px;
              font-weight: bold;
              color: rgba($color: #374151, $alpha: 0.8);
            }
  
            .content {
              font-size: 16px;
              line-height: 1.75;
              font-weight: 400;
              color: #374151;
              letter-spacing: 0.48px;
              display: inline-block;
              background: #f1f1f1;
              padding: 12px;
              white-space: pre-wrap;
            }
          }
  
          &.text-right {
            justify-content: flex-end;
            margin-right: 0;
  
            .content {
              background: #e0d9ca;
            }
  
            .name {
              text-align: right;
            }
  
            img {
              margin-left: 13px;
              margin-right: 0;
            }
  
            .info-box {
              &::before {
                display: none;
              }
              &::after {
                content: '';
                position: absolute;
                top: 28px;
                right: -6px;
                transform: translateY(-50%);
                width: 0;
                height: 0;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 6px solid #e0d9ca;
              }
            }
          }
        }
      }
    }
  
    .ask-wrapper {
      display: flex;
      align-items: center;
      flex-basis: 165px;
      position: relative;
      .loading-box {
        position: absolute;
        left: 50%;
        top: 10px;
        border: 1px solid $primary;
        transform: translateX(-50%);
        border-radius: 8px;
        padding: 10px 20px;
        cursor: pointer;
        .txt {
          font-size: 16px;
          color: $primary;
          letter-spacing: 1px;
          display: flex;
          align-items: center;
          &::before {
            content: '';
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 4px;
            margin-right: 3px;
            background: $primary;
          }
        }
      }
      .svg-wrapper {
        width: 55px;
        height: 55px;
        display: flex;
        align-items: center;
        border-radius: 27px;
        margin-right: 18px;
        cursor: pointer;
        transition: all linear 0.5s;
        background: $primary;
        position: relative;
        .svg-inner {
          width: 28px;
          height: 28px;
          margin-left: 27px;
          margin-top: 27px;
          transform: translate(-50%, -50%);
  
          .clear-icon {
            width: 28px;
            height: 28px;
            color: #fff;
          }
        }
  
        .theme {
          width: 0;
          color: #fff;
          font-size: 16px;
          white-space: nowrap;
          overflow: hidden;
        }
  
        &:hover {
          width: 116px;
  
          .theme {
            width: 68px;
          }
        }
      }
  
      .input-wrapper {
        position: relative;
        flex: 1;
        height: 48px;
  
        .ask {
          position: absolute;
          bottom: 0;
          top: auto;
          height: auto;
  
          ::v-deep .el-textarea__inner {
            min-height: 48px !important;
            max-height: 300px;
  
            &::-webkit-scrollbar {
              width: 6px;
              height: 6px;
            }
  
            &::-webkit-scrollbar-thumb {
              background: rgba($color: #374151, $alpha: 0.3);
              border-radius: 3px;
            }
  
            &::-webkit-scrollbar-track {
              border-radius: 3px;
            }
          }
        }
      }
    }
  }
  </style>
  